var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEvaluationEmptyState(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 380.56,
    height: 224.497,
    viewBox: "0 0 380.56 224.497",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -518.946,
    y1: -377.148,
    x2: -518.573,
    y2: -377.148,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#edf2ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f4f6fd"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_4849",
    x: 164,
    y: 85.93,
    width: 95.669,
    height: 72.722,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.051
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_4882",
    x: 75,
    y: 85.93,
    width: 95.669,
    height: 72.722,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.051
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_4852",
    x: 165,
    y: 21.856,
    width: 95.669,
    height: 72.722,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-3"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.051
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-3"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_4881",
    x: 75.665,
    y: 21.856,
    width: 95.669,
    height: 72.722,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-4"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.051
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-4"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_4858",
    x: 164,
    y: 151.775,
    width: 95.669,
    height: 72.722,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-5"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.051
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-5"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Path_4883",
    x: 75,
    y: 151.775,
    width: 95.669,
    height: 72.722,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur-6"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.051
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur-6"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4860",
    "data-name": "Path 4860",
    d: "M1938.466,2355.295c-.029,0-.058,0-.087,0l-38.1-.038a1.736,1.736,0,0,1,0-3.471l38.1.039a1.737,1.737,0,0,1,.083,3.469Z",
    transform: "translate(-1898.58 -2351.786)",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -10.169,
    y1: -31.833,
    x2: -10.165,
    y2: -31.833,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#08005d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1a0e90"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -22.402,
    y1: -30.537,
    x2: -22.394,
    y2: -30.537,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: -4.359,
    y1: -2.355,
    x2: -4.357,
    y2: -2.355,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: -189.92,
    y1: -29.051,
    x2: -189.851,
    y2: -29.051,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: -9.495,
    y1: -4.166,
    x2: -9.491,
    y2: -4.166,
    xlinkHref: "#linear-gradient-2"
  }), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern",
    preserveAspectRatio: "none",
    width: "100%",
    height: "100%",
    viewBox: "0 0 515 44"
  }, /*#__PURE__*/React.createElement("image", {
    width: 515,
    height: 44,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAgMAAAAsCAYAAAD4vrudAAAACXBIWXMAAA7EAAAOxAGVKw4bAAAA1klEQVR4nO3WMQHAIADAsDEBCEA1jkEGRxMFPTvW3OcDALL+1wEAwFtmAADizAAAxJkBAIgzAwAQZwYAIM4MAECcGQCAODMAAHFmAADizAAAxJkBAIgzAwAQZwYAIM4MAECcGQCAODMAAHFmAADizAAAxJkBAIgzAwAQZwYAIM4MAECcGQCAODMAAHFmAADizAAAxJkBAIgzAwAQZwYAIM4MAECcGQCAODMAAHFmAADizAAAxJkBAIgzAwAQZwYAIM4MAECcGQCAODMAAHFmAADizAAAxF3awQIPPIM14AAAAABJRU5ErkJggg=="
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern-2",
    preserveAspectRatio: "xMidYMid slice",
    width: "100%",
    height: "100%",
    viewBox: "0 0 515 44"
  }, /*#__PURE__*/React.createElement("image", {
    width: 515,
    height: 44,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAgMAAAAsCAYAAAD4vrudAAAACXBIWXMAAA7EAAAOxAGVKw4bAAAA1klEQVR4nO3WMQHAIADAsDEBCEA1jkEGRxMFPTvW3OcDALL+1wEAwFtmAADizAAAxJkBAIgzAwAQZwYAIM4MAECcGQCAODMAAHFmAADizAAAxJkBAIgzAwAQZwYAIM4MAECcGQCAODMAAHFmAADizAAAxJkBAIgzAwAQZwYAIM4MAECcGQCAODMAAHFmAADizAAAxJkBAIgzAwAQZwYAIM4MAECcGQCAODMAAHFmAADizAAAxJkBAIgzAwAQZwYAIM4MAECcGQCAODMAAHFmAADizAAAxF3awQIPPIM14AAAAABJRU5ErkJggg=="
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4758",
    "data-name": "Group 4758",
    transform: "translate(9523 5356.261)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4753",
    "data-name": "Group 4753",
    transform: "translate(-881.954 -6006.457)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4825",
    "data-name": "Path 4825",
    d: "M2493.3,1715.767a2.66,2.66,0,0,0-2.744-2.613l-57.592,1.84a2.66,2.66,0,0,0-2.573,2.738l2.842,95.381a2.659,2.659,0,0,0,2.684,2.579l56.434-.548a2.661,2.661,0,0,0,2.634-2.706Z",
    transform: "translate(-10755.476 -962.319)",
    fill: "#75d5ef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4826",
    "data-name": "Path 4826",
    d: "M877.285,665.97s19.029-116.763-29.69-200.424a1.734,1.734,0,0,0-2.913-.142C833.123,481.65,764.615,587.327,877.285,665.97Z",
    transform: "translate(-9276.711 185.518)",
    fill: "#e0f3fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4885",
    "data-name": "Path 4885",
    d: "M877.285,665.97s19.029-116.763-29.69-200.424a1.734,1.734,0,0,0-2.913-.142C833.123,481.65,764.615,587.327,877.285,665.97Z",
    transform: "translate(-9541.223 864.805) rotate(-39)",
    fill: "#e0f3fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4888",
    "data-name": "Path 4888",
    d: "M877.285,665.97s19.029-116.763-29.69-200.424a1.734,1.734,0,0,0-2.913-.142C833.123,481.65,764.615,587.327,877.285,665.97Z",
    transform: "translate(-9288.725 1495.671) rotate(-76)",
    fill: "#e0f3fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4828",
    "data-name": "Path 4828",
    d: "M553.627,1088.467S553.206,952.211,488.9,912.12a2.087,2.087,0,0,0-3.078,1.107C480.82,928.05,459.5,1008.529,553.627,1088.467Z",
    transform: "translate(-8995.637 -261.608)",
    fill: "#e0f3fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4829",
    "data-name": "Path 4829",
    d: "M1389.052,3029.158c-.007-.21-.014-.427-.023-.648l.19.346v0a.2.2,0,0,1-.08.273A.217.217,0,0,1,1389.052,3029.158Z",
    transform: "translate(-9798.054 -2171.646)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4831",
    "data-name": "Path 4831",
    d: "M2020.6,1373.421a2.216,2.216,0,0,0-2.407-2.157l-61.6,5.336a2.248,2.248,0,0,0-2.06,2.208v123.836a2.2,2.2,0,0,0,2.287,2.123h64.508a2.139,2.139,0,0,0,2.215-2.2Z",
    transform: "translate(-10317.97 -647.982)",
    fill: "#e0f3fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4832",
    "data-name": "Path 4832",
    d: "M1570.011,1690.53a2.4,2.4,0,0,0-2.495-2.364l-49.137,1.97a1.547,1.547,0,0,0-1.484,1.582l2.5,105.044,49.684-.606a2.4,2.4,0,0,0,2.37-2.433Z",
    transform: "translate(-9915.611 -939.345)",
    fill: "#75d5ef"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4833",
    "data-name": "Path 4833",
    d: "M1585.753,1803.584l-.093-13.514h7.924l.076,13.512Z",
    transform: "translate(-9978.834 -1033.036)",
    fill: "#e0f3fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4834",
    "data-name": "Path 4834",
    d: "M1587.4,2042.969l-.093-13.414,7.9-.025.076,13.4Z",
    transform: "translate(-9980.351 -1253.193)",
    fill: "#e0f3fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4835",
    "data-name": "Path 4835",
    d: "M1728.417,2042.495l-.068-13.39,7.871-.025.051,13.373Z",
    transform: "translate(-10110.021 -1252.779)",
    fill: "#e0f3fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4836",
    "data-name": "Path 4836",
    d: "M1589.1,2288l-.092-13.329,7.874-.051.075,13.312Z",
    transform: "translate(-9981.914 -1478.527)",
    fill: "#e0f3fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4837",
    "data-name": "Path 4837",
    d: "M1729.658,2287.075l-.068-13.3,7.846-.051.05,13.288Z",
    transform: "translate(-10111.162 -1477.699)",
    fill: "#e0f3fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4838",
    "data-name": "Path 4838",
    d: "M1877.462,2286.109l-.042-13.279,7.814-.05.025,13.262Z",
    transform: "translate(-10247.075 -1476.835)",
    fill: "#e0f3fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4839",
    "data-name": "Path 4839",
    d: "M2023.07,2285.164l.066-13.253,7.867-.05V2285.1Z",
    transform: "translate(-10380.984 -1475.989)",
    fill: "#e0f3fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4840",
    "data-name": "Path 4840",
    d: "M1590.789,2531.155l-.089-12.929,7.849-.076.073,12.913Z",
    transform: "translate(-9983.468 -1702.426)",
    fill: "#e0f3fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4841",
    "data-name": "Path 4841",
    d: "M1730.9,2529.791l-.065-12.906,7.82-.075.049,12.89Z",
    transform: "translate(-10112.302 -1701.194)",
    fill: "#e0f3fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4842",
    "data-name": "Path 4842",
    d: "M1878.23,2528.346l-.04-12.882,7.789-.075.024,12.865Z",
    transform: "translate(-10247.783 -1699.888)",
    fill: "#e0f3fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4843",
    "data-name": "Path 4843",
    d: "M2023.37,2526.951l.067-12.856,7.843-.075v12.84Z",
    transform: "translate(-10381.261 -1698.628)",
    fill: "#e0f3fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4844",
    "data-name": "Path 4844",
    d: "M1592.459,2773.078l-.09-12.848,7.824-.1.073,12.831Z",
    transform: "translate(-9985.003 -1924.9)",
    fill: "#e0f3fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4845",
    "data-name": "Path 4845",
    d: "M1732.125,2771.273l-.065-12.824,7.795-.1.049,12.808Z",
    transform: "translate(-10113.433 -1923.264)",
    fill: "#e0f3fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4846",
    "data-name": "Path 4846",
    d: "M1878.99,2769.369l-.04-12.8,7.764-.1.024,12.783Z",
    transform: "translate(-10248.482 -1921.535)",
    fill: "#e0f3fb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4847",
    "data-name": "Path 4847",
    d: "M2023.68,2767.525l.066-12.776,7.818-.1v12.76Z",
    transform: "translate(-10381.545 -1919.861)",
    fill: "#e0f3fb"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -8641.05, 650.2)",
    filter: "url(#Path_4849)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4849-2",
    "data-name": "Path 4849",
    d: "M854.255,1659.833H780.079a1.747,1.747,0,0,1-1.746-1.747v-51.229a1.747,1.747,0,0,1,1.746-1.747h74.176a1.747,1.747,0,0,1,1.747,1.747v51.229A1.747,1.747,0,0,1,854.255,1659.833Z",
    transform: "translate(-605.33 -1513.18)",
    fill: "#fff",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -8641.05, 650.2)",
    filter: "url(#Path_4882)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4882-2",
    "data-name": "Path 4882",
    d: "M854.255,1659.833H780.079a1.747,1.747,0,0,1-1.746-1.747v-51.229a1.747,1.747,0,0,1,1.746-1.747h74.176a1.747,1.747,0,0,1,1.747,1.747v51.229A1.747,1.747,0,0,1,854.255,1659.833Z",
    transform: "translate(-694.33 -1513.18)",
    fill: "#fff",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_4850",
    "data-name": "Path 4850",
    d: "M963.9,1715.832l-2.689,1.5a58.983,58.983,0,0,1-5.388,2.6c6.554-.4,17.642-2.247,18.994-10.178.686-4.026-.153-7.1-2.493-9.137-3.631-3.161-10.064-3.047-14.831-1.535-5.4,1.714-9.371,6.736-8.676,10.968.631,3.841,5.005,5.99,12,5.843Zm-12.265,4.185h0Zm.176,1.34h0Zm.73.211c-.373,0-.688,0-.938-.01a.858.858,0,0,1-.21-1.684,41.976,41.976,0,0,0,6.414-2.533c-8.489-.692-10.184-5.052-10.511-7.046-.826-5.029,3.538-10.72,9.73-12.686,6.318-2,12.719-1.282,16.307,1.841,1.907,1.66,3.975,4.838,3,10.558C974.514,1720.71,957.826,1721.567,952.546,1721.567Z",
    transform: "translate(-9391.246 -946.997)",
    fill: "#feba40"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -8641.05, 650.2)",
    filter: "url(#Path_4852)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4852-2",
    "data-name": "Path 4852",
    d: "M865.875,864.969H791.7a1.747,1.747,0,0,1-1.747-1.747V811.993a1.747,1.747,0,0,1,1.747-1.747h74.176a1.747,1.747,0,0,1,1.747,1.747v51.228A1.747,1.747,0,0,1,865.875,864.969Z",
    transform: "translate(-615.95 -782.39)",
    fill: "#fff",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -8641.05, 650.2)",
    filter: "url(#Path_4881)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4881-2",
    "data-name": "Path 4881",
    d: "M865.875,864.969H791.7a1.747,1.747,0,0,1-1.747-1.747V811.993a1.747,1.747,0,0,1,1.747-1.747h74.176a1.747,1.747,0,0,1,1.747,1.747v51.228A1.747,1.747,0,0,1,865.875,864.969Z",
    transform: "translate(-705.29 -782.39)",
    fill: "#fff",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4755",
    "data-name": "Group 4755",
    transform: "translate(9.437)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3983",
    "data-name": "Group 3983",
    transform: "translate(-8453.482 685.6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4853",
    "data-name": "Path 4853",
    d: "M965.051,905.1a2.289,2.289,0,0,0-2.286,2.286v18.191a2.289,2.289,0,0,0,2.286,2.286h23.555a2.289,2.289,0,0,0,2.286-2.286V907.381a2.289,2.289,0,0,0-2.286-2.286Zm23.555,23.977H965.051a3.5,3.5,0,0,1-3.5-3.5V907.381a3.5,3.5,0,0,1,3.5-3.5h23.555a3.5,3.5,0,0,1,3.5,3.5v18.191A3.5,3.5,0,0,1,988.606,929.072Z",
    transform: "translate(-961.551 -903.881)",
    fill: "#30c5cc",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4854",
    "data-name": "Path 4854",
    d: "M995.491,935.527l-14.2-10.652.729-.971,13.49,10.12,13.832-9.811.7.99Z",
    transform: "translate(-980.268 -922.865)",
    fill: "#30c5cc",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4855",
    "data-name": "Path 4855",
    d: "M1357.223,1070.711l-8.833-15.654,1.057-.6,8.833,15.654Z",
    transform: "translate(-1328.326 -1046.65)",
    fill: "#30c5cc",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4856",
    "data-name": "Path 4856",
    d: "M975.325,1066.645l-1.063-.587,8.681-15.738,1.063.587Z",
    transform: "translate(-973.603 -1042.724)",
    fill: "#30c5cc",
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -8641.05, 650.2)",
    filter: "url(#Path_4858)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4858-2",
    "data-name": "Path 4858",
    d: "M854.255,2476.691H780.079a1.746,1.746,0,0,1-1.746-1.746v-51.229a1.747,1.747,0,0,1,1.746-1.747h74.176a1.747,1.747,0,0,1,1.747,1.747v51.229A1.746,1.746,0,0,1,854.255,2476.691Z",
    transform: "translate(-605.33 -2264.19)",
    fill: "#fff",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -8641.05, 650.2)",
    filter: "url(#Path_4883)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4883-2",
    "data-name": "Path 4883",
    d: "M854.255,2476.691H780.079a1.746,1.746,0,0,1-1.746-1.746v-51.229a1.747,1.747,0,0,1,1.746-1.747h74.176a1.747,1.747,0,0,1,1.747,1.747v51.229A1.746,1.746,0,0,1,854.255,2476.691Z",
    transform: "translate(-694.33 -2264.19)",
    fill: "#fff",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4757",
    "data-name": "Group 4757",
    transform: "translate(6.211)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4859",
    "data-name": "Path 4859",
    d: "M1039.9,2533.153c2.752,1.927,5.058,2.728,6.85,2.381a3.946,3.946,0,0,0,2.6-1.836l.727-1.115a.619.619,0,0,0-.174-.851l-4.617-3.078a.9.9,0,0,0-1.235.219l-.337.519a3.042,3.042,0,0,1-4.769.424l-5.594-5.594a3.041,3.041,0,0,1,.424-4.769l.519-.336a.9.9,0,0,0,.22-1.236l-3.078-4.617a.62.62,0,0,0-.851-.174l-1.115.727a3.949,3.949,0,0,0-1.837,2.6c-.347,1.793.454,4.1,2.38,6.849A97.71,97.71,0,0,0,1039.9,2533.153Zm6.014,3.649c-1.911,0-4.157-.9-6.7-2.674h0a97.234,97.234,0,0,1-10.182-10.182c-2.118-3.027-2.984-5.636-2.574-7.758a5.163,5.163,0,0,1,2.354-3.367l1.115-.728a1.814,1.814,0,0,1,2.491.511l3.078,4.617a2.088,2.088,0,0,1-.528,2.872l-.021.015-.531.344a1.851,1.851,0,0,0-.253,2.907l.015.015L1039.8,2529a1.851,1.851,0,0,0,2.907-.253l.358-.551a2.087,2.087,0,0,1,2.872-.528l4.617,3.078a1.814,1.814,0,0,1,.511,2.491l-.728,1.115a5.16,5.16,0,0,1-3.368,2.354A5.558,5.558,0,0,1,1045.913,2536.8Z",
    transform: "translate(-9474.62 -1696.589)",
    fill: "#db5a28",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_4861",
    "data-name": "Path 4861",
    d: "M2242.951,3082.4a38.613,38.613,0,0,1,.465,4.05,1.744,1.744,0,0,1-1.571,1.84c-3.253.316-10.654.9-15.381.216a.794.794,0,0,1-.435-1.365,24.547,24.547,0,0,1,14.4-6.12Z",
    transform: "translate(-10567.352 -2219.923)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4862",
    "data-name": "Path 4862",
    d: "M2394.873,3026.482l-1.645,4.03a1.342,1.342,0,0,1-1.378.833,7.233,7.233,0,0,1-1.343-.261,1.765,1.765,0,0,1-1.174-2.194l1.241-4.151Z",
    transform: "translate(-10717.655 -2168.18)",
    fill: "#fcb593",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4863",
    "data-name": "Path 4863",
    d: "M2754.414,3137.939a17.252,17.252,0,0,0-4.576,6.289,1.5,1.5,0,0,0,1.427,2h6.775a1.6,1.6,0,0,0,1.579-1.869C2759.188,3141.915,2757.943,3137.949,2754.414,3137.939Z",
    transform: "translate(-11049.087 -2272.255)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient-3)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4864",
    "data-name": "Path 4864",
    d: "M2800.627,3087.741s-.665,2.944-1.176,4.889a.622.622,0,0,1-.813.424,5.672,5.672,0,0,0-2.466-.447.479.479,0,0,1-.529-.478l-.063-4.889Z",
    transform: "translate(-11091.224 -2225.642)",
    fill: "#fcb593",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4865",
    "data-name": "Path 4865",
    d: "M2412.585,2184.936l-20.025,61.093s3.841,2.515,5.671,2.41l23.785-49.1s4.163,30.252,2.146,51.971l6.813.52s11.077-55.5,2.687-74.513Z",
    transform: "translate(-10720.69 -1389.07)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient-4)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4866",
    "data-name": "Path 4866",
    d: "M2745.311,2369.189l.024,0a.193.193,0,0,0,.167-.217l-.777-6.168a.194.194,0,0,0-.384.048l.777,6.169A.2.2,0,0,0,2745.311,2369.189Z",
    transform: "translate(-11044.113 -1559.445)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient-5)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4867",
    "data-name": "Path 4867",
    d: "M2372.055,1604.9s16.224,1.44,13.929,13a157.606,157.606,0,0,1,13.161,36.759,1.169,1.169,0,0,1-.948,1.39l-27.019,4.626a1.454,1.454,0,0,1-1.654-1.069l-6.456-24.951-2.516,11.6-7.993-2.083,6.729-34.086S2360.227,1605.113,2372.055,1604.9Z",
    transform: "translate(-10683.914 -862.792)",
    fill: "#96c4ea",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4868",
    "data-name": "Path 4868",
    d: "M2453.243,1837.66a.206.206,0,0,0,.043,0,.2.2,0,0,0,.154-.24l-2.252-10.341a.2.2,0,1,0-.393.085l2.252,10.342A.2.2,0,0,0,2453.243,1837.66Z",
    transform: "translate(-10774.227 -1066.912)",
    fill: "#6aa5cc",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4869",
    "data-name": "Path 4869",
    d: "M2437.7,2139a3.861,3.861,0,0,1,2.79-.363l1.88.468a.681.681,0,0,0,.842-.585l1.945-17.315c2.433,1.155,5.942,1.016,7.1.933l-4.478,20.413H2432.11Z",
    transform: "translate(-10757.053 -1337.483)",
    fill: "#fcb593",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4870",
    "data-name": "Path 4870",
    d: "M1985.01,1741.753l.473-1.573a3.115,3.115,0,0,1,1.82-1.992l8.566-3.444s.129-1.1-1.81-1.845a2.577,2.577,0,0,1-1.486-2.918s2.649,1.208,6.528,3.125a9.084,9.084,0,0,1,4.122,4.489l19.408,23.66-2.279,1.566a6.083,6.083,0,0,1-8.82-2.165l-10.515-20.162A39.2,39.2,0,0,1,1985.01,1741.753Z",
    transform: "translate(-10345.992 -977.789)",
    fill: "#fcb593",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4871",
    "data-name": "Path 4871",
    d: "M2470.258,1466.1l4.99,13.966s-4.419,3.454-7.643,2.286l-2.515-8.005S2467.011,1464.561,2470.258,1466.1Z",
    transform: "translate(-10787.374 -735.029)",
    fill: "#fcb593",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4872",
    "data-name": "Path 4872",
    d: "M2344.45,1374.06c0,.215,4.806,13.608,4.806,13.608l7.589-2.908-2.671-13.37S2344.45,1370.456,2344.45,1374.06Z",
    transform: "translate(-10676.459 -648.005)",
    fill: "#fcb593",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4873",
    "data-name": "Path 4873",
    d: "M2309.167,1321.85l1.957,6.927a1,1,0,0,1,.038.271c0,.565-.14,2.509-2.12,2.245-1.8-.239-3.441-.432-4.486.06a1,1,0,0,0-.518,1.249,43.506,43.506,0,0,0,2.733,6.169,1,1,0,0,0,1.29.413,32.378,32.378,0,0,0,6.507-3.827,1,1,0,0,0,.355-.965c-.332-1.772-1.323-7.163-1.366-8.708-.041-1.45,1.586-2.557,2.3-2.973a.987.987,0,0,0,.465-.625,2.606,2.606,0,0,0-2.278-3.51,1.008,1.008,0,0,1-.817-1.2,2.612,2.612,0,0,0-1.964-3.364,3.684,3.684,0,0,0-4.2,1.677,1.007,1.007,0,0,1-1.247.333.8.8,0,0,0-.892.16.991.991,0,0,1-1.449-.221,3,3,0,0,0-3.7-1.222c-3.428,1.109-3.265,5.062-2.008,7.211s4.906.735,6.633-.688c1.313-1.083,3.312-.435,4.2-.063A1,1,0,0,1,2309.167,1321.85Z",
    transform: "translate(-10632.781 -595.208)",
    fillRule: "evenodd",
    fill: "url(#linear-gradient-6)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4874",
    "data-name": "Path 4874",
    d: "M2498.492,1426.584s-2.029-3.838-.687-5.044,3.615-1.008,3.553,1.993C2501.283,1427.267,2498.492,1426.584,2498.492,1426.584Z",
    transform: "translate(-10817.03 -693.577)",
    fill: "#fcb593",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4875",
    "data-name": "Path 4875",
    d: "M2586.025,1817.809a19.3,19.3,0,0,0,1.983-.094l.144-.016,5.908-27.544a.2.2,0,1,0-.393-.084l-5.846,27.258c-.879.077-5.574.389-8.052-1.366l5.117-23.931-1.068-2.013a.2.2,0,0,0-.355.189l1,1.884-5.141,24.041.1.077C2581.214,1817.554,2584.1,1817.809,2586.025,1817.809Z",
    transform: "translate(-10892.396 -1032.889)",
    fill: "#6aa5cc",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4876",
    "data-name": "Path 4876",
    d: "M2231.885,2435.4c.155.524,14.908,45.849,18.648,57.34.431,1.324-.772,2.624-2.427,2.624a2.472,2.472,0,0,1-2.439-1.579l-16.377-54.392Z",
    transform: "translate(-10570.582 -1626.346)",
    fill: "#7d97f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4877",
    "data-name": "Path 4877",
    d: "M1947.561,2435.4c-.155.524-14.908,45.849-18.648,57.34-.431,1.324.772,2.624,2.427,2.624a2.472,2.472,0,0,0,2.438-1.579l16.377-54.392Z",
    transform: "translate(-10294.337 -1626.346)",
    fill: "#7d97f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4878",
    "data-name": "Path 4878",
    d: "M2153.63,2412.96h9.188v7.379a1.909,1.909,0,0,1-1.9,1.92h-1.26v16.574a1.436,1.436,0,1,1-2.873,0v-16.574h-.64a2.534,2.534,0,0,1-2.518-2.549Z",
    transform: "translate(-10501.021 -1605.715)",
    fill: "#7d97f4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4879",
    "data-name": "Path 4879",
    d: "M1849.856,2390.97h-64.292a1.944,1.944,0,0,0-1.908,1.194l-.9,2.809c-.322,1.011.627,2,1.919,1.989l65.97-.306c1.279-.006,2.212-.979,1.9-1.98l-.781-2.5A1.94,1.94,0,0,0,1849.856,2390.97Z",
    transform: "translate(-10159.985 -1585.498)",
    fill: "#7d97f4"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4754",
    "data-name": "Group 4754",
    transform: "translate(6.657)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3987",
    "data-name": "Group 3987",
    transform: "translate(-8539.481 685.6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4853-2",
    "data-name": "Path 4853",
    d: "M965.051,905.1a2.289,2.289,0,0,0-2.286,2.286v18.191a2.289,2.289,0,0,0,2.286,2.286h23.555a2.289,2.289,0,0,0,2.286-2.286V907.381a2.289,2.289,0,0,0-2.286-2.286Zm23.555,23.977H965.051a3.5,3.5,0,0,1-3.5-3.5V907.381a3.5,3.5,0,0,1,3.5-3.5h23.555a3.5,3.5,0,0,1,3.5,3.5v18.191A3.5,3.5,0,0,1,988.606,929.073Z",
    transform: "translate(-961.551 -903.881)",
    fill: "#db5a28",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4854-2",
    "data-name": "Path 4854",
    d: "M995.491,935.527l-14.2-10.652.729-.971,13.49,10.12,13.832-9.811.7.99Z",
    transform: "translate(-980.268 -922.865)",
    fill: "#db5a28",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4855-2",
    "data-name": "Path 4855",
    d: "M1357.223,1070.711l-8.833-15.654,1.057-.6,8.834,15.654Z",
    transform: "translate(-1328.326 -1046.65)",
    fill: "#db5a28",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4856-2",
    "data-name": "Path 4856",
    d: "M975.325,1066.645l-1.063-.587,8.681-15.738,1.063.587Z",
    transform: "translate(-973.603 -1042.724)",
    fill: "#db5a28",
    fillRule: "evenodd"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_4886",
    "data-name": "Path 4886",
    d: "M961.358,1712.884l-2.279,1.271a49.99,49.99,0,0,1-4.567,2.2c5.555-.335,14.953-1.9,16.1-8.627.581-3.413-.129-6.019-2.113-7.744-3.078-2.679-8.53-2.583-12.57-1.3-4.575,1.453-7.943,5.709-7.354,9.3.535,3.256,4.243,5.078,10.175,4.953Zm-10.4,3.547h0Zm.149,1.135h0Zm.619.179c-.316,0-.583,0-.8-.008a.727.727,0,0,1-.178-1.427,35.555,35.555,0,0,0,5.437-2.147c-7.2-.586-8.632-4.282-8.909-5.972-.7-4.263,3-9.086,8.247-10.752,5.355-1.7,10.78-1.087,13.822,1.56,1.616,1.407,3.37,4.1,2.543,8.949C970.352,1717.018,956.206,1717.745,951.731,1717.745Z",
    transform: "translate(-9478.246 -946.997)",
    fill: "#30c5cc"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4756",
    "data-name": "Group 4756",
    transform: "translate(4.508)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4887",
    "data-name": "Path 4887",
    d: "M1039.9,2533.153c2.752,1.927,5.058,2.728,6.85,2.381a3.947,3.947,0,0,0,2.6-1.836l.727-1.115a.619.619,0,0,0-.174-.851l-4.617-3.078a.9.9,0,0,0-1.235.219l-.337.519a3.041,3.041,0,0,1-4.769.424l-5.594-5.594a3.041,3.041,0,0,1,.424-4.769l.519-.337a.9.9,0,0,0,.22-1.236l-3.078-4.617a.62.62,0,0,0-.851-.174l-1.115.728a3.948,3.948,0,0,0-1.837,2.6c-.347,1.793.454,4.1,2.38,6.849A97.725,97.725,0,0,0,1039.9,2533.153Zm6.014,3.649c-1.911,0-4.157-.9-6.7-2.674h0a97.237,97.237,0,0,1-10.182-10.182c-2.118-3.027-2.984-5.636-2.574-7.758a5.162,5.162,0,0,1,2.354-3.368l1.115-.728a1.815,1.815,0,0,1,2.491.511l3.078,4.617a2.088,2.088,0,0,1-.528,2.872l-.021.015-.531.344a1.851,1.851,0,0,0-.253,2.907l.015.015L1039.8,2529a1.852,1.852,0,0,0,2.907-.253l.359-.551a2.086,2.086,0,0,1,2.872-.528l4.617,3.078a1.813,1.813,0,0,1,.511,2.491l-.728,1.115a5.16,5.16,0,0,1-3.368,2.354A5.56,5.56,0,0,1,1045.913,2536.8Z",
    transform: "translate(-9561.916 -1697.046)",
    fill: "#30c5cc",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3985",
    "data-name": "Group 3985",
    transform: "translate(-8379.827 765.242)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3984",
    "data-name": "Group 3984",
    transform: "translate(11.878 37.072)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1700",
    "data-name": "Rectangle 1700",
    width: 41.507,
    height: 3.51,
    fill: "url(#pattern)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_4880",
    "data-name": "Path 4880",
    d: "M39.886,3.508c-.029,0-.058,0-.087,0L1.7,3.471A1.721,1.721,0,0,1,0,1.734,1.712,1.712,0,0,1,1.707,0L39.8.039a1.721,1.721,0,0,1,1.7,1.737A1.724,1.724,0,0,1,39.886,3.508Z",
    transform: "matrix(-0.259, -0.966, 0.966, -0.259, 10.743, 41.001)",
    fillRule: "evenodd",
    fill: "url(#pattern-2)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "noun_Compare_2794343",
    transform: "translate(-8467.858 697.982) rotate(90)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4752",
    "data-name": "Group 4752",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4745",
    "data-name": "Group 4745",
    transform: "translate(0 0.003)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4744",
    "data-name": "Group 4744"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5582",
    "data-name": "Path 5582",
    d: "M.713,2.78l.7-.7L2.524.968,2.779.714H2.186l.7.7L4,2.525l.255.255a.42.42,0,1,0,.593-.593l-.7-.7L3.034.375,2.779.12a.426.426,0,0,0-.593,0l-.7.7L.375,1.932l-.255.255a.425.425,0,0,0,0,.593.427.427,0,0,0,.592,0Z",
    fill: "#a0a5ba"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4747",
    "data-name": "Group 4747",
    transform: "translate(2.064 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4746",
    "data-name": "Group 4746"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5583",
    "data-name": "Path 5583",
    d: "M0,.42V7.779c0,.1,0,.2,0,.3v.013a.424.424,0,0,0,.419.419.427.427,0,0,0,.419-.419V.732c0-.1,0-.2,0-.3V.42A.424.424,0,0,0,.42,0,.427.427,0,0,0,0,.42Z",
    fill: "#a0a5ba"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4749",
    "data-name": "Group 4749",
    transform: "translate(5.333 7.284)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4748",
    "data-name": "Group 4748"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5584",
    "data-name": "Path 5584",
    d: "M.12.714l.7.7L1.932,2.525l.255.255a.426.426,0,0,0,.593,0l.7-.7L4.591.969,4.846.714a.425.425,0,0,0,0-.593.427.427,0,0,0-.593,0l-.7.7L2.441,1.932l-.255.255H2.78l-.7-.7L.968.375.714.121a.425.425,0,0,0-.593,0,.426.426,0,0,0,0,.593Z",
    fill: "#a0a5ba"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4751",
    "data-name": "Group 4751",
    transform: "translate(7.395 1.676)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4750",
    "data-name": "Group 4750"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5585",
    "data-name": "Path 5585",
    d: "M.839,8.091V.732c0-.1,0-.2,0-.3V.42A.424.424,0,0,0,.42,0,.427.427,0,0,0,0,.42V7.779c0,.1,0,.2,0,.3v.013a.424.424,0,0,0,.419.419.427.427,0,0,0,.419-.419Z",
    fill: "#a0a5ba"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "noun_Compare_2794343-2",
    "data-name": "noun_Compare_2794343",
    transform: "translate(-8467.858 760.449) rotate(90)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4752-2",
    "data-name": "Group 4752",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4745-2",
    "data-name": "Group 4745",
    transform: "translate(0 0.003)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4744-2",
    "data-name": "Group 4744"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5582-2",
    "data-name": "Path 5582",
    d: "M.713,2.78l.7-.7L2.524.968,2.779.714H2.186l.7.7L4,2.525l.255.255a.42.42,0,1,0,.593-.593l-.7-.7L3.034.375,2.779.12a.426.426,0,0,0-.593,0l-.7.7L.375,1.932l-.255.255a.425.425,0,0,0,0,.593.427.427,0,0,0,.592,0Z",
    fill: "#a0a5ba"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4747-2",
    "data-name": "Group 4747",
    transform: "translate(2.064 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4746-2",
    "data-name": "Group 4746"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5583-2",
    "data-name": "Path 5583",
    d: "M0,.42V7.779c0,.1,0,.2,0,.3v.013a.424.424,0,0,0,.419.419.427.427,0,0,0,.419-.419V.732c0-.1,0-.2,0-.3V.42A.424.424,0,0,0,.42,0,.427.427,0,0,0,0,.42Z",
    fill: "#a0a5ba"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4749-2",
    "data-name": "Group 4749",
    transform: "translate(5.333 7.284)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4748-2",
    "data-name": "Group 4748"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5584-2",
    "data-name": "Path 5584",
    d: "M.12.714l.7.7L1.932,2.525l.255.255a.426.426,0,0,0,.593,0l.7-.7L4.591.969,4.846.714a.425.425,0,0,0,0-.593.427.427,0,0,0-.593,0l-.7.7L2.441,1.932l-.255.255H2.78l-.7-.7L.968.375.714.121a.425.425,0,0,0-.593,0,.426.426,0,0,0,0,.593Z",
    fill: "#a0a5ba"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4751-2",
    "data-name": "Group 4751",
    transform: "translate(7.395 1.676)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4750-2",
    "data-name": "Group 4750"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5585-2",
    "data-name": "Path 5585",
    d: "M.839,8.091V.732c0-.1,0-.2,0-.3V.42A.424.424,0,0,0,.42,0,.427.427,0,0,0,0,.42V7.779c0,.1,0,.2,0,.3v.013a.424.424,0,0,0,.419.419.427.427,0,0,0,.419-.419Z",
    fill: "#a0a5ba"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "noun_Compare_2794343-3",
    "data-name": "noun_Compare_2794343",
    transform: "translate(-8467.858 826.606) rotate(90)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4752-3",
    "data-name": "Group 4752",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4745-3",
    "data-name": "Group 4745",
    transform: "translate(0 0.003)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4744-3",
    "data-name": "Group 4744"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5582-3",
    "data-name": "Path 5582",
    d: "M.713,2.78l.7-.7L2.524.968,2.779.714H2.186l.7.7L4,2.525l.255.255a.42.42,0,1,0,.593-.593l-.7-.7L3.034.375,2.779.12a.426.426,0,0,0-.593,0l-.7.7L.375,1.932l-.255.255a.425.425,0,0,0,0,.593.427.427,0,0,0,.592,0Z",
    fill: "#a0a5ba"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4747-3",
    "data-name": "Group 4747",
    transform: "translate(2.064 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4746-3",
    "data-name": "Group 4746"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5583-3",
    "data-name": "Path 5583",
    d: "M0,.42V7.779c0,.1,0,.2,0,.3v.013a.424.424,0,0,0,.419.419.427.427,0,0,0,.419-.419V.732c0-.1,0-.2,0-.3V.42A.424.424,0,0,0,.42,0,.427.427,0,0,0,0,.42Z",
    fill: "#a0a5ba"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4749-3",
    "data-name": "Group 4749",
    transform: "translate(5.333 7.284)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4748-3",
    "data-name": "Group 4748"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5584-3",
    "data-name": "Path 5584",
    d: "M.12.714l.7.7L1.932,2.525l.255.255a.426.426,0,0,0,.593,0l.7-.7L4.591.969,4.846.714a.425.425,0,0,0,0-.593.427.427,0,0,0-.593,0l-.7.7L2.441,1.932l-.255.255H2.78l-.7-.7L.968.375.714.121a.425.425,0,0,0-.593,0,.426.426,0,0,0,0,.593Z",
    fill: "#a0a5ba"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_4751-3",
    "data-name": "Group 4751",
    transform: "translate(7.395 1.676)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4750-3",
    "data-name": "Group 4750"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5585-3",
    "data-name": "Path 5585",
    d: "M.839,8.091V.732c0-.1,0-.2,0-.3V.42A.424.424,0,0,0,.42,0,.427.427,0,0,0,0,.42V7.779c0,.1,0,.2,0,.3v.013a.424.424,0,0,0,.419.419.427.427,0,0,0,.419-.419Z",
    fill: "#a0a5ba"
  }))))), /*#__PURE__*/React.createElement("text", {
    id: "PRODUCT_1",
    "data-name": "PRODUCT 1",
    transform: "translate(-8537.046 724.457)",
    fill: "#a0a5ba",
    fontSize: 7,
    fontFamily: "Inter-SemiBold, Inter",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "PRODUCT 1")), /*#__PURE__*/React.createElement("text", {
    id: "PRODUCT_2",
    "data-name": "PRODUCT 2",
    transform: "translate(-8449.046 724.457)",
    fill: "#a0a5ba",
    fontSize: 7,
    fontFamily: "Inter-SemiBold, Inter",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "PRODUCT 2")), /*#__PURE__*/React.createElement("text", {
    id: "PRODUCT_1-2",
    "data-name": "PRODUCT 1",
    transform: "translate(-8537.046 788.457)",
    fill: "#a0a5ba",
    fontSize: 7,
    fontFamily: "Inter-SemiBold, Inter",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "PRODUCT 1")), /*#__PURE__*/React.createElement("text", {
    id: "PRODUCT_2-2",
    "data-name": "PRODUCT 2",
    transform: "translate(-8449.046 788.457)",
    fill: "#a0a5ba",
    fontSize: 7,
    fontFamily: "Inter-SemiBold, Inter",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "PRODUCT 2")), /*#__PURE__*/React.createElement("text", {
    id: "PRODUCT_1-3",
    "data-name": "PRODUCT 1",
    transform: "translate(-8537.046 854.457)",
    fill: "#a0a5ba",
    fontSize: 7,
    fontFamily: "Inter-SemiBold, Inter",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "PRODUCT 1")), /*#__PURE__*/React.createElement("text", {
    id: "PRODUCT_2-3",
    "data-name": "PRODUCT 2",
    transform: "translate(-8449.046 854.457)",
    fill: "#a0a5ba",
    fontSize: 7,
    fontFamily: "Inter-SemiBold, Inter",
    fontWeight: 600
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "PRODUCT 2"))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEvaluationEmptyState);
export default __webpack_public_path__ + "static/media/evaluation_empty_state.afea75e45cdfd33293ae7eca7b902268.svg";
export { ForwardRef as ReactComponent };